export function useIsMultiTenant() {
  const config = useRuntimeConfig();

  const isMultiTenant = computed(() => {
    return $ck.utils.parseBoolean(config.public.MULTI_TENANT);
  });

  return {
    isMultiTenant,
  };
}
